import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ dark = false }: { dark?: boolean }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith('ja') ? 'ja' : 'en';

  const changeLanguage = (language: 'ja' | 'en') => {
    void i18n.changeLanguage(language);
    localStorage.setItem('petf-language', language);
  };

  return (
    <div className={`inline-flex rounded-full border p-1 ${dark ? 'border-white/20 bg-white/10' : 'border-[#d7d7ce] bg-white/70'}`} aria-label="Language">
      {(['ja', 'en'] as const).map((language) => (
        <button
          key={language}
          type="button"
          onClick={() => changeLanguage(language)}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${current === language ? (dark ? 'bg-white text-[#173c31]' : 'bg-[#214f3f] text-white') : (dark ? 'text-white/65 hover:text-white' : 'text-[#62675f] hover:text-[#214f3f]')}`}
          aria-pressed={current === language}
        >
          {language === 'ja' ? '日本語' : 'English'}
        </button>
      ))}
    </div>
  );
}
